/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('#open_menu').click(function () {
  $('#open_menu').toggleClass('is-hidden');
  $('#close_menu').toggleClass('is-hidden');
});

$('#close_menu').click(function () {
  $('#open_menu').toggleClass('is-hidden');
  $('#close_menu').toggleClass('is-hidden');
});

const drawer = $('#sidebar-cart');
const listItemDrawer = $(
  ".Header__Wrapper .HorizontalList__Item button[data-action='toggle-drawer']"
);
let temp_selected = null;
listItemDrawer.click(function () {
  if (drawer.attr('aria-hidden') === 'true') {
    temp_selected = $('.Header__Wrapper .HorizontalList__Item.is_selected');
    temp_selected.removeClass('is_selected');
    $(this).parent().addClass('is_selected');
  } else if (drawer.attr('aria-hidden') === 'false') {
    temp_selected = $('.Header__Wrapper .HorizontalList__Item.is_selected');
    temp_selected.removeClass('is_selected');
    $(this).parent().removeClass('is_selected');
  }
});

$('.PageOverlay').click(function () {
  if (drawer.attr('aria-hidden') === 'false') {
    listItemDrawer.parent().removeClass('is_selected');
    if (temp_selected) {
      temp_selected.addClass('is_selected');
      temp_selected = null;
    }
  }
});

$(document).on('cart:refresh', function () {
  setTimeout(function () {
    $('.Drawer__Footer .button_close').click(function () {
      listItemDrawer.parent().removeClass('is_selected');
      if (temp_selected) {
        temp_selected.addClass('is_selected');
        temp_selected = null;
      }
    });
  }, 1000);
});

if ($(window).width() > 640) {
  $(window).scroll(function () {
    // const headerHeight = Number($("html").css("--header-height").slice(0, -2));
    if (window.scrollY <= 15) {
      $('.Header__Logo').css('opacity', 1);
      $('.Header__Logo .Header__LogoLink').css('cursor', 'pointer');
      $('.Product__Info').css('padding-top', window.scrollY + 'px');
    } else {
      $('.Header__Logo').css('opacity', 0);
      $('.Header__Logo .Header__LogoLink').css('cursor', 'default');
    }
  });
}

$(window).ready(function () {
  if ($('.weglot-link-en').length) {
    $('.weglot-link-en').parent().addClass('Weglot_EN');
  }

  if ($('.weglot-link-en').length) {
    $('.weglot-link-fr').parent().addClass('Weglot_FR');
  }
});
